// extracted by mini-css-extract-plugin
module.exports = {"level-2-bg":"SignInButton_level-2-bg__wDgay","link":"SignInButton_link__wb7Yw","button":"SignInButton_button__el46S"};